import AppForm from "../app-components/Form/AppForm";

Vue.component("companies-form", {
    mixins: [AppForm],
    props: {
        "companyContractsTypes": {
            type: Array
        }
    },

    data: function() {
        return {
            form: {
                id_number: "",
                name: "",
                settings: {}
            },
            isEdit: false
        };
    },

    methods: {
        goBack() {
            window.location.href = "/companies";
        },

        sanitizeDecimalPoint(val) {
            return (val ? val.replace(",", ".") : val);
        },

        sanitizeIncorrectFloatChars(val) {
            val = this.sanitizeDecimalPoint(val);
            return (val ? val.replace(/[^0-9.]/, "") : val);
        },

        correctBasicInputDecimals(vmodelName, $event) {
            this.form.settings[vmodelName] = this.sanitizeIncorrectFloatChars($event.target.value);
        }
    }
});



// WEBPACK FOOTER //
// ./resources/assets/admin/js/companies/Form.js